jQuery(function ($) {
	const $form = $('#Form_Form');

	$('.lot__submitOffer').on('click', function (e) {
		e.preventDefault();

		$('#Form_Form_LotNumber').val($(this).attr('data-lot-number'));
		$('#Form_Form_LotTitle').val($(this).attr('data-title'));

		$('#Form_Form_LotNumber_Holder').children('label').addClass('filled');
		$('#Form_Form_LotTitle_Holder').children('label').addClass('filled');

		$form[0].scrollIntoView();
	});

	$(".searchForm__input.filter").change(function() {
		if (window.location.hash) {
		    history.replaceState({}, document.title, window.location.pathname + window.location.search);
		}
	    // Get the selected category ID
	    var selectedCategoryId = $(this).val();

	    // Get the current URL
	    var currentUrl = window.location.href;

	    // Check if the URL contains a fragment identifier
	    var fragmentIndex = currentUrl.indexOf('#');
	    if (fragmentIndex !== -1) {
	        // Remove the fragment identifier
	        currentUrl = currentUrl.substring(0, fragmentIndex);
	    }

	    // Check if the URL already contains a query string
	    if (currentUrl.includes('?')) {
	        // Check if the categoryID parameter already exists
	        if (currentUrl.includes('categoryID=')) {
	            // Replace the existing categoryID parameter value
	            var newUrl = currentUrl.replace(/categoryID=\d+/i, 'categoryID=' + selectedCategoryId);
	            window.location.href = newUrl;
	        } else {
	            // Append the selected category ID to the existing query string
	            window.location.href = currentUrl + '&categoryID=' + selectedCategoryId;
	        }
	    } else {
	        // Append the selected category ID as a new query string
	        window.location.href = currentUrl + '?categoryID=' + selectedCategoryId;
	    }
	});


});
